import React from "react";
import { Link } from "react-router-dom";
import {
  MdArrowBack as BackIcon,
  MdArrowForward as ForwardIcon
} from "react-icons/md";
import { isMobileDevice } from "../../utils/mobile";
import AppBar, { AppBarContentWrapper } from "../AppBar/AppBar";

export const AuthNavHome = ({ theme }) =>
  isMobileDevice() && (
    <AppBar showBackButton>
      <AppBarContentWrapper>
        <Link to="/">
          {theme.scriptDirection === "RTL" ? (
            <ForwardIcon size={24} />
          ) : (
            <BackIcon size={24} />
          )}
        </Link>
      </AppBarContentWrapper>
    </AppBar>
  );
